import { ItemDataSuggestionState } from './types';

export const defaultState: ItemDataSuggestionState = {
  error: undefined,
  loading: {
    create: false
  }
};
